/**
 * Marks "the renderer just advanced gaplessly on its own" (#11452).
 *
 * Two questions, kept separate on purpose:
 *  - recent: did a gapless advance happen lately? (double-advance and pre-buffered-play guards)
 *  - deferral owned: does the renderer still own the NEXT transition for the track it adopted?
 *    That ends the moment the user skips (generation bump) or stops, so the skipped-to or resumed
 *    track gets its own end-of-track advance instead of waiting on a transition nobody will make.
 */
const RECENT_WINDOW_MS = 120_000;

let advancedAt = 0;
let deferralGeneration = -1;

export function stampGaplessAdvance(generation: number): void {
  advancedAt = Date.now();
  deferralGeneration = generation;
}

export function isGaplessAdvanceRecent(withinMs = RECENT_WINDOW_MS): boolean {
  return advancedAt > 0 && Date.now() - advancedAt < withinMs;
}

export function endGaplessDeferral(): void {
  deferralGeneration = -1;
}

export function isGaplessDeferralOwned(generation: number): boolean {
  return deferralGeneration === generation && isGaplessAdvanceRecent();
}
